export default __webpack_public_path__ + "static/media/icon-step-five1.306fdb61.png";